import {checkIfAlreadyProsted} from "../prost/checkIfAlreadyProsted";
import {getCommentCommentContainerCodeHtml} from "./getCommentCommentContainerCodeHtml";
import {showSubComments} from "./showSubComments";
import {stringToDate} from "../utils/stringToDate";
import {dateToString} from "../utils/dateToString";

export function populateCommentComments(id, unparsedComment) {
    var data = $.parseJSON(unparsedComment);
    var comments = data.comments;
    var commentContainer = $('#comment_' + id);

    var commentIds = "(-1";
    $.each(comments, function (key, value) {
        if (shownCommentComments[id] === undefined) {
            shownCommentComments[id] = 1;
        } else {
            shownCommentComments[id]++;
        }
        var dateObject = stringToDate(value.comment_date);
        var dateString = dateToString(dateObject, true);

        var communityUser = {};
        communityUser["shop_user_id"] = value.shop_user_id;
        communityUser["nickname"] = value.nickname;
        communityUser["nickname_slug"] = value.nickname_slug;
        communityUser["slogan"] = value.slogan;
        communityUser["image"] = value.image;
        commentIds += "," + value.id;
        getCommentCommentContainerCodeHtml(value.content, dateString, id, 'pre', value.id, communityUser, value.sum_prosts, value.sum_comments, "false");
    });
    if (data.loadMoreContainer) {
        commentContainer.find('.comment_comments').prepend(data.loadMoreContainer);
    }
    commentIds += ")";
    checkIfAlreadyProsted("", commentIds, shopUserId, true, 0);
    var commentLink = commentContainer.find(".more_comment_comments_link");
    commentLink.on('click', function (e) {
        e.preventDefault();
        var container = $(this).closest(".display_comment");
        var id = container.attr("id").split('_')[1];
        var countComments = parseInt(container.find(".comments .comment_count_comment").text().split(' ')[0]);
        if (shownCommentComments[id] < countComments) {
            var loadableElements = countComments - shownCommentComments[id];
            if (loadableElements > 3) {
                loadableElements = 3;
            }
            commentContainer.find('.comment_comments').find('.more_comment_comments_link').remove();
            showSubComments(id, loadableElements);
        }
    });
    if (shownCommentComments[id] < data.count) {
        if (commentLink.hasClass("hidden")) {
            commentLink.removeClass("hidden");
        }
    } else {
        if (!commentLink.hasClass("hidden")) {
            commentLink.addClass("hidden");
        }
    }
}